var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$route.meta.class_parent,attrs:{"id":"app"}},[_c(_vm.$route.meta.layout || 'div',{tag:"component"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }